




















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import Cuenta from "@/models/cuenta";
import Tarjeta from "@/models/tarjeta";
import BTableColumn from "@/models/base/BTableColumn.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import AppNotificationReceiver from "@/models/appNotification";
import { RowTable } from "@/typings/BRowTable";
import { AppNotificationType } from "@/enums/Codes";
import Helpers from "@/helpers/helper";
import { sanitizeRichHtml } from "@/helpers/security";

@Component
export default class AppNotificationsTable extends GenericBTable<
  AppNotificationReceiver
> {
  @Prop() public show!: boolean;
  filterTable: any = {};
  appNotificationRepo = new BaseRepository<AppNotificationReceiver>(
    "AppNotificationReceiver"
  );
  created() {
    if (this.user) this.setupTable();
  }
  setupTable() {
    this.tableConfig.controller = "AppNotificationReceiver";
    this.tableConfig.include = "AppNotification";
    this.tableConfig.detailed = true;
    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.actions.customTemplate = true;
    this.tableConfig.whereParams = this.getFiltros;
    let subject = new BTableColumn("subject", "Asunto", false);
    let read = new BTableColumn("read", "Visto");
    read.type = BTableColumnType.Bool;
    let fecha = new BTableColumn("createdDate", "Fecha");
    fecha.type = BTableColumnType.DateTime;
    this.tableConfig.insertColumns(subject, read, fecha);
  }
  sanitizeMessage(message: string) {
    return sanitizeRichHtml(message);
  }
  protected ver(
    data: AppNotificationReceiver,
    props: RowTable<AppNotificationReceiver>
  ) {
    this.$emit("update:show", false);
    this.appNotificationDetail(data);
    //this.$router.push(`${this.$router.currentRoute.path}/editar/${id}`);
  }

  appNotificationDetail(item: AppNotificationReceiver) {
    this.markAsReadAN(item);
    switch (item.type) {
      case AppNotificationType.TRAMITE_COMPLETADO:
        this.$router.push(`/resumen-solicitud/${item.refEntityDetailValue}`);
        break;
      case AppNotificationType.TRAMITE_RECHAZADO:
        this.$router.push(`/resumen-solicitud/${item.refEntityDetailValue}`);
        break;
      case AppNotificationType.PSONLINE_TRAMITE_COMENTADO:
        this.$router.push(`/resumen-solicitud/${item.refEntityDetailValue}`);
        break;
      default:
        break;
    }
  }
  async markAsReadAN(item: AppNotificationReceiver) {
    if (item) {
      if (item.read === false) {
        try {
          let id = item.id as number;
          await this.appNotificationRepo.client.putAsync(
            "MarkAsRead",
            id,
            item
          );
          Helpers.EventBus.$emit("APP_NOTIFICATION_MARKED_AS_READ", item);
        } catch (error) {
          this.operationFailedErrors(error);
        }
      }
    }
  }
  get getFiltros() {
    let filtros = [];
    if (this.filter.fechaDesde)
      filtros.push(
        `createdDate >= ${this.getDateTimeOffsetFormatDate(
          this.filter.fechaDesde
        )}`
      );
    if (this.filter.fechaHasta)
      filtros.push(
        `createdDate <= ${this.getDateTimeOffsetFormatDate(
          this.filter.fechaHasta
        )}`
      );
    if (this.filter.visto === false || this.filter.visto === true)
      filtros.push(`read==${this.filter.visto}`);
    filtros.push(`receiverId==${this.user.id}`);

    let fil = filtros.join("&&");

    if (this.filter.searchText) {
      let result = [];
      result.push(`appnotification.subject.Contains("${this.filter.searchText}")`);
      return fil ? `${fil}&&(${result.join("||")})` : result.join("||");
    }
    return fil;
  }

  search() {
    this.tableConfig.whereParams = this.getFiltros;
    if (this.tableConfig.reload) this.tableConfig.reload();
  }
  async confirmRemove(
    id: number,
    data: AppNotificationReceiver,
    props: RowTable<AppNotificationReceiver>
  ) {
    try {
      await this.repository.delete(id);
      this.operationSuccess("Registro eliminado!");
      if (this.tableConfig.reload) this.tableConfig.reload();
      this.$emit("remove", id, data, props);
    } catch (e) {
      this.operationFailed(e);
    } finally {
      this.$emit("update:show", false);
    }
  }
}
